import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

const createOrder = (productId) => {
    return axios.get(`${CoreService.getPrivateURL()}order/create/${productId.toString()}`, {withCredentials:true})
};

const PaymentService = {
  createOrder,
};
export default PaymentService;
